import Vue from 'vue';
import batchTransformer from '../../transformers/batch';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(batchTransformer.fetch(errors));
};

export default (id, batch) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .put(`/production/batch/${id}`, batch)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/batch/update.js